import React from "react";
import ReactDOM from "react-dom";
import TemperatureReview from "./TemperatureReview";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
    <React.StrictMode>
        <TemperatureReview />
    </React.StrictMode>,
    document.getElementById("root")
);
